module.exports = __webpack_public_path__ + "static/media/0.2df3ed25.svg";